<template>
  <div>
    <!-- 联系人卡片 -->
    <div class="sy-cell_between adressbox">
      <div class="avter">
        <span class="name">海瑟薇</span>&nbsp;<span class="phone">13129987654</span>
        <span class="ellipsis">北京市 海淀区 八里庄街道，五棵松25号院3号楼502室</span>
      </div>
      <van-icon name="arrow" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Ardess',
  data() {
    return {
      list: [{
        name: '张三',
        tel: '13000000000',
        id: 0
      }]
    }
  },

  methods: {

  }
}
</script>
<style lang="scss" scoped>
.adressbox{
  background: #fff;
  padding: 12px;
  height: auto;
  margin-bottom: 15px;
}
.avter{
  font-size:13px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:19px;
}
.ellipsis{
  width: 339px;
  -webkit-line-clamp: 1;
  margin-top: 6px;

}
</style>

